import { toast } from 'react-toastify';

const defaultErrorToast = ({ message }) =>
  toast.error(message, {
    position: 'top-right',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

export default defaultErrorToast;
